import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "../css/home.css";
import { Link } from "react-router-dom";
import logo from "../img/logo.png";
function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">

          {/* Brand / About */}
          <div className="col-md-4 mb-4">
                 <h5 className="footer-title"> <img className="footer-logo " src={logo} alt="NeatNest Logo" /> NeatNest</h5>
          
            <p className="footer-text">
              Professional home cleaning service providing reliable, affordable,
              and high-quality cleaning solutions. Your home, sparkling clean!
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-md-4 mb-4">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-4 mb-4">
            <h5 className="footer-title">Contact Us</h5>
            <p className="footer-text">📧 info@NeatNest.com</p>
            <p className="footer-text">📞 +91 9867291149</p>

            <div className="footer-socials">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          © {new Date().getFullYear()} NeatNest. All Rights Reserved. <br /> Designed & Developed By nikitas
        </div>
      </div>
    </footer>
  );
}

export default Footer;
